import React from 'react'
import cx from 'classnames'
import ArrowForward from '@material-ui/icons/ArrowForward'

const ArrowLink = ({ text, url, textCx }) => {
  return (
    <div className='arrow-link arrow flex'>
      <a
        href={url}
        className={cx('dib f7', textCx)}
      >
        {text}
        <ArrowForward className={cx('vm ml3')} />
      </a>
    </div>
  )
}

export default ArrowLink
